<kendo-dialog *ngIf="dialogOpened" (close)="close()" [width]="600" [height]="500">
    <kendo-dialog-titlebar>
        <h3 *ngIf="isNew">{{ (createMode === 'SPACE' ? 'ADD-SPACE': 'ADD-CHAT') | translate }}</h3>
        <h3 *ngIf="!isNew">{{ (createMode === 'SPACE' ? 'EDIT-SPACE': 'EDIT-CHAT') | translate }}</h3>
    </kendo-dialog-titlebar>
    <form novalidate [formGroup]="selectionForm" class="k-form">
        <div class="row" *ngIf="createMode === 'SPACE'">
            <div class="col-12">
                <label for="spaceName" class="k-form-field w-100">
                    <span class="k-text-uppercase dark">
                        {{'SPACE-NAME' | translate}} *
                    </span>
                    <input id="spaceName" kendoTextBox formControlName="spaceName" maxlength="64" />
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="spaceName.hasError('required') && spaceName.touched">
                        {{'REQUIRED-NAME' | translate}}
                    </div>
                    <div class="k-tooltip k-tooltip-validation" role="alert" *ngIf="spaceName.hasError('nameExists')">
                        {{'SPACE-NAME-ALREADY-EXISTS' | translate}}
                    </div>
                </label>
            </div>
        </div>
        <div class="row" *ngIf="createMode === 'SPACE'">
            <div class="col-12">
                <label for="spaceDescription" class="k-form-field w-100">
                    <span class="k-text-uppercase dark">
                        {{'DESCRIPTION' | translate}}
                    </span>
                    <textarea id="spaceDescription" kendoTextArea class="w-100" rows="2"
                        formControlName="spaceDescription" maxlength="1024">
                    </textarea>
                </label>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <label class="k-form-field w-100">
                    <span class="k-text-uppercase dark">
                        {{ 'USERS' | translate }} *
                    </span>
                    <kendo-multiselect [data]="allUsers" formControlName="users" [textField]="'name'"
                        attr.aria-label="{{ 'USERS' | translate }}" [filterable]="false" [valueField]="'id'"
                        [autoClose]="true" [itemDisabled]="itemDisabled">
                        <ng-template kendoMultiSelectTagTemplate let-dataItem>{{ dataItem.name }}<i
                                *ngIf="isOnline(dataItem.id)" class="fa fa-circle fa-xs ml-1 chat-online-icon"
                                title="{{'ONLINE' | translate}}"></i>
                        </ng-template>
                    </kendo-multiselect>
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="users.hasError('required') && users.touched">
                        {{'REQUIRED-USERS-SELECTION' | translate}}
                    </div>
                </label>
            </div>
        </div>
    </form>
    <kendo-dialog-actions>
        <button class="k-button" (click)="close()">{{ 'CANCEL' | translate }}</button>
        <button appPreventClick class="k-button k-primary" (click)="onSave()"
            [disabled]="!selectionForm.valid || !selectionForm.dirty || !users || users.value.length < 2">
            <span>{{ 'SAVE' | translate }}</span>
        </button>
    </kendo-dialog-actions>
</kendo-dialog>